// بيستخرج اللون الحقيقي لرمز/ليجند الجسة من صورته نفسها (مش تخمين بالاسم)
// عشان لون المسطرة والطبقات يطابق شكل الرمز اللي المستخدم مختاره فعلاً
const colorCache = new Map();

export const getDominantColorFromImage = (url) => {
  if (!url) return Promise.resolve(null);
  if (colorCache.has(url)) return Promise.resolve(colorCache.get(url));

  return new Promise(resolve => {
    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = () => {
      try {
        const size = 32;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, size, size);
        const { data } = ctx.getImageData(0, 0, size, size);

        let r = 0, g = 0, b = 0, count = 0;
        for (let i = 0; i < data.length; i += 4) {
          const alpha = data[i + 3];
          if (alpha < 40) continue; // بكسل شفاف تقريبًا
          const [pr, pg, pb] = [data[i], data[i + 1], data[i + 2]];
          if (pr > 235 && pg > 235 && pb > 235) continue; // خلفية بيضاء تقريبًا
          r += pr; g += pg; b += pb; count += 1;
        }

        // لو كل البكسلات طلعت شفافة/بيضاء (صورة فاتحة جدًا)، بناخد متوسط الصورة كلها بدل ما نرجع فاضي
        if (count === 0) {
          for (let i = 0; i < data.length; i += 4) {
            r += data[i]; g += data[i + 1]; b += data[i + 2]; count += 1;
          }
        }

        const hex = count > 0
          ? `#${[r, g, b]
              .map(c => Math.round(c / count).toString(16).padStart(2, '0'))
              .join('')}`
          : null;

        colorCache.set(url, hex);
        resolve(hex);
      } catch (err) {
        colorCache.set(url, null);
        resolve(null);
      }
    };

    img.onerror = () => {
      colorCache.set(url, null);
      resolve(null);
    };

    img.src = url;
  });
};
